/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconDiagnosticCollection = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps(iconProps);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", width: "1em", height: "1em", "aria-label": "icon", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7a8 8 0 0 0-8 8v15h16.96a2 2 0 0 1 1.83 1.192l3.763 8.521 9.215-21.016a2 2 0 0 1 3.648-.034L44.641 30H60V15a8 8 0 0 0-8-8H12Zm48 27H43.36a2 2 0 0 1-1.816-1.163l-3.899-8.46-9.253 21.105a2 2 0 0 1-3.662.005L19.657 34H4v15a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8V34Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h64v64H0z" })))));
});
IconDiagnosticCollection.displayName = 'IconDiagnosticCollection';
export default IconDiagnosticCollection;
